import { render, staticRenderFns } from "./GachaAnimation.vue?vue&type=template&id=5be8bf0d&scoped=true&"
import script from "./GachaAnimation.vue?vue&type=script&lang=js&"
export * from "./GachaAnimation.vue?vue&type=script&lang=js&"
import style0 from "./GachaAnimation.vue?vue&type=style&index=0&id=5be8bf0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8bf0d",
  null
  
)

export default component.exports